export default __webpack_public_path__ + "static/media/stool-cabinet.d3c53863.png";